import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';

import 'firebase/firestore';
//image
import my_account from '../assets/images/icon-user-inactive@2x.png';
import profile_thumb from '../assets/images/Account-icon.svg';
import wallet from '../assets/images/icon-wallet-inactive@2x.png';
import add_credit from '../assets/images/icon-card-inactive@2x.png';
import logout_image from '../assets/images/icon-logout-inactive@2x.png';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faUserCircle} from '@fortawesome/free-solid-svg-icons'
//internal
import * as actions from "../actions";
import {
    checkIfUserIsOnBroadcasterSection,
    isEmpty,
    logout,
    makeUserOnline,
    navigate,
    openIframe,
    removeWordFromList
} from "../util/utility";
import {getData, LOGIN, setData, USER_DATA} from "../util/storage";
import UserProfile from "../components/UserProfile"
import {
    checkIfBroadcasterVerified,
    checkIfMobileNumberIsVerified,
    checkIfVoucherAvailable,
    showPromocodeVerification
} from "../util/broadcaster/register_util";
import firebase from '../../src/assets/libs/firebase';
import {getProfanityWords} from "../util/firebase/firestore";
import YotiIframe from "./modal/YotiIframe";
import PromoCode from "./ApplyPromocode";
import {BROADCASTER, checkIfUserDataAvailable, getUserDetail, USER} from "../util/account_management";
import {getMoneyBloxWalletBalance} from "../assets/libs/MoneyBlox";
import {getEncryptedIdForBroadcaster} from "../util/broadcast_util";
import sb_util from "../util/sb/util";


class NavigationBar extends Component {

    static propTypes = {
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props);
        this.dropDownClickListener = this.dropDownClickListener.bind(this);
        this.showUserProfile = this.showUserProfile.bind(this);
        this.updateStatus = this.updateStatus.bind(this);
        this.state = {
            userProfileModal: false,
            commonmodalState: false,
            yotiModalStatus: false,
            searchValue:''
        }
    }


    /**
     * @function is invoked immediately after a component is mounted. Initialization that requires DOM nodes should go here.
     * If you need to load data from a remote endpoint, this is a good place to instantiate the network request.
     */
    componentDidMount() {
        //every time the NavigationBar is loaded we check if the user api_token and token is available
        //it the api_token and token is available we do hit getUserDetails Webservice
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.getUserDetails(data.token, data.api_token);
                }
            })

        // Getting list of profanity data
        getProfanityWords((jsonData) => {
            this.props.setProfanityWord(jsonData.word);
        })
    }

    /**
     * @function This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        if (window.location.pathname.indexOf("/broadcaster") >= 0) {
            //this is broadcaster lets make the Go live as active
            if (document.getElementById("top-nav-go-live")) {
                document.getElementById("top-nav-go-live").classList.add("active")
                document.getElementById("top-nav-watch").classList.remove("active")
            }
        } else {
            //this is viewer lets make the Watch as active
            if (document.getElementById("top-nav-watch")) {
                document.getElementById("top-nav-go-live").classList.remove("active")
                document.getElementById("top-nav-watch").classList.add("active")
            }
        }

        if (checkIfUserDataAvailable(nextProps)) {

            // if the status_code received from the server is 200 means the user data is received
            if (nextProps.account_management.userDetails !== null &&
                nextProps.account_management.userDetails !== undefined &&
                nextProps.account_management.userDetails.isReset !== true &&
                this.props.account_management.userDetails === null) {

                setData(USER_DATA, nextProps.account_management.userDetails, () => {
                    getMoneyBloxWalletBalance(this.props);
                    this.props.resetUserData(nextProps.account_management.userDetails, true)
                });
            }
        }

        if (nextProps.account_management.userDetails && nextProps.account_management.userDetails.hasOwnProperty("broadcaster")) {
            this.setState(
                { userProfileModal: true }
            );
            makeUserOnline(nextProps.account_management.userDetails.user_id);
        }
        // || window.location.pathname.indexOf("/broadcast") >= 0
        if (window.location.pathname.indexOf("/dashboard") >= 0) {
            const searchInput = document.getElementsByName('searchInput')[0]
            if (searchInput) {
                searchInput.placeholder = 'search broadcasters by username or tags';
            }

        }
        else if (window.location.pathname.indexOf("following") >= 0) {
            const searchInput = document.getElementsByName('searchInput')[0]
            if (searchInput) {
                searchInput.placeholder = 'search followers by username';
            }
        }
        else if (window.location.pathname.indexOf("/broadcaster/create/broadcast") >= 0 || window.location.pathname.indexOf("/broadcaster/followers") >= 0) {
            const searchInput = document.getElementsByName('searchInput')[0]
            if (searchInput) {
                searchInput.placeholder = 'search followers by username';
            }
        }

        else if (window.location.pathname.indexOf("/broadcaster/favourites") >= 0) {
            const searchInput = document.getElementsByName('searchInput')[0]
            if (searchInput) {
                searchInput.placeholder = 'search favourites by username';
            }
        }

        if (nextProps.account_management.yotiDetails !== null && nextProps.account_management.userDetails.broadcaster[0].is_verified === 0) {
            this.state.yotiModalStatus && openIframe(nextProps.account_management.yotiDetails.url);
            this.setState({
                yotiModalStatus: false
            })
        }
    }

    /**
     * @function toggles the state of dropdown menu
     */
    dropDownClickListener = () => {
        document.getElementsByClassName("dropdown")[0].classList.toggle("show");
        document.getElementsByClassName("dropdown-menu")[0].classList.toggle("show");

        if (window.location.pathname.indexOf("/broadcaster/") >= 0) {
            document.getElementsByClassName("add-credit-li")[0].style.display = "none"
            if (this.checkIfBroadcasterAvailable(this.props)) {
                document.getElementsByClassName("my-wallet-li")[0].style.display = "block"
                if (checkIfBroadcasterVerified(this.props) && checkIfMobileNumberIsVerified(this.props)) {
                    document.getElementsByClassName("my-account-li")[0].style.display = "block"
                    document.getElementsByClassName("verify-account-li")[0].style.display = "none"
                    document.getElementsByClassName("promotions-li")[0].style.display = "none"
                    // check broadcaster is verified and voucher key has length greater than one then show Promotions text
                    if (checkIfVoucherAvailable(this.props)) {
                        document.getElementsByClassName("promotions-li")[0].style.display = "block"
                    }
                } else {
                    document.getElementsByClassName("my-account-li")[0].style.display = "none"
                    document.getElementsByClassName("promotions-li")[0].style.display = "none"
                    document.getElementsByClassName("verify-account-li")[0].style.display = "block"
                    document.getElementsByClassName("promotions-li")[0].style.display = "none"
                }
            }
            else {
                document.getElementsByClassName("my-wallet-li")[0].style.display = "none"
                // document.getElementsByClassName("my-account-li")[0].style.display = "none"
            }
        }
        else {
            document.getElementsByClassName("add-credit-li")[0].style.display = "block";
            document.getElementsByClassName("my-account-li")[0].style.display = "block";
            document.getElementsByClassName("verify-account-li")[0].style.display = "none"
            document.getElementsByClassName("my-wallet-li")[0].style.display = "none"
            document.getElementsByClassName("promotions-li")[0].style.display = "none"
        }
    };

    /**
     * @function notification is the right bell icon which is use to access notification for viewer and broadcaster
     */
    toggleNotification = () => {
        if (window.location.pathname.indexOf("broadcaster") >= 0) {
            // if (checkIfBroadcasterVerified(this.props)) {
                document.getElementsByClassName("rightNotification")[0].classList.toggle("expanded");
                document.getElementsByClassName("notify")[0].classList.toggle("expanded");
            // }
        } else {
            document.getElementsByClassName("rightNotification")[0].classList.toggle("expanded");
            document.getElementsByClassName("notify")[0].classList.toggle("expanded");
        }

        if (document.getElementById("rightNotification").className === "rightNotification expanded") {
            let user_id = getUserDetail(this.props, USER, "user_id");
            if (user_id) {

                let user_type = window.location.pathname.indexOf("broadcaster") >= 0 && this.checkIfBroadcasterAvailable(this.props) ? 1 : 0

                this.props.requestNotificationList()
                this.getListOfNotifications(user_id, user_type, (data) => {
                    this.props.setNotificationList(data)
                })
            }
        }

    };

    checkIfBroadcasterAvailable = (props) => {
        return props.account_management.userDetails.broadcaster !== null &&
            props.account_management.userDetails.broadcaster.length > 0
    }

    /**
     * @function left bar is the section for viewers where they can perform filtering of broadcast and access their
     * Moneyblox account
     */
    toggleLeftBar = () => {
        document.getElementsByClassName("nav-toggle")[0].classList.toggle("expanded");
        document.getElementsByClassName("leftNav")[0].classList.toggle("expanded");
        //document.getElementsByClassName("overlay")[0].classList.toggle("expanded");
    };


    showUserProfile = () => {

        document.getElementsByClassName("dropdown")[0].classList.toggle("show");
        document.getElementsByClassName("dropdown-menu")[0].classList.toggle("show");

        if (window.location.pathname.indexOf("broadcaster") >= 0) {
            //broadcaster
            const broadcaster_id = getUserDetail(this.props,BROADCASTER,"id");
            if(broadcaster_id){
                const encryptBroadcasterId = getEncryptedIdForBroadcaster(broadcaster_id)
                this.props.history.push(`/broadcaster/profile/${encryptBroadcasterId}`);
            }
        } else {
            //user
            this.props.history.push("/user/profile");
        }
    };


    /**
     * Fetch all the notifications of last seven days depending on parameters
     * @param id
     * @param user_type
     */
    getListOfNotifications(id, user_type, callback) {
        const db = firebase.firestore();
        const settings = {};
        db.settings(settings);
        var date = new Date();
        date.setDate(date.getDate() - 7);

        db.collection("users").doc(id).collection("notifications").orderBy('send_at', 'desc').where("user_type", "==", user_type).where("send_at", ">=", date)
            .get()
            .then(function (querySnapshot) {
                var notificationList = [];
                var dataCount = 0
                if (querySnapshot.empty) {
                    callback(notificationList)
                } else {
                    querySnapshot.forEach(function (doc, index, array) {
                        // doc.data() is never undefined for query doc snapshots
                        dataCount++;
                        let notificationData = {
                            ...doc.data(),
                            id: doc.id
                        };
                        notificationList.push(notificationData)
                        if (dataCount === querySnapshot.docs.length) {
                            callback(notificationList)
                        }
                    });
                }
            })
            .catch(function (error) {
                callback([])
            });
    }

    searchInTheList = (e) => {
        e.preventDefault();
        if (checkIfUserIsOnBroadcasterSection()) {
            const leftNavFavElement = document.getElementById("leftNavFavourites")
            const leftNavGoLiveElement = document.getElementById("leftNavGoLive")
            if ((leftNavFavElement && leftNavFavElement.className.indexOf("active") > 0) ||
                (leftNavGoLiveElement && leftNavGoLiveElement.className.indexOf("active") > 0)) {
                const isFavouritesTabActive = leftNavFavElement.className.indexOf("active") > 0
                if (isFavouritesTabActive) {
                    this.props.history.push("/broadcaster/favourites")
                    this.props.setSearchFavouritesState(true)

                }
                else {
                    this.props.history.push("/broadcaster/followers")
                    this.props.setSearchFollowersState(true)
                }

            }
            else {
                this.props.history.push("/broadcaster/followers")
                this.props.setSearchFollowersState(true)
            }

        } else {
            const leftNavElement = document.getElementById("leftNavLiveNow")
            if (leftNavElement && leftNavElement.className.indexOf("active") > 0) {
                const isLiveNowTabActive = leftNavElement.className.indexOf("active") > 0
                if (isLiveNowTabActive) {
                    this.props.history.push("/dashboard")
                    this.props.setSearchForBroadcasterState(true)
                }
                else {
                    this.props.history.push("/following")
                    this.props.setSearchFollowingState(true)
                }
            }
        }
    }

    handleOnBlur = (event) => {
        const newData = removeWordFromList(this.props.account_management.userDetails && this.props.account_management.userDetails.user_id, this.props.profanity, event.target.value, false, true);
        event.target.value = newData;
        this.setState({
            searchValue:newData
        })
    }

    updateStatus() {
        //dispatch an action to Update the broadcaster status to online
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.updateBroadcasterStatus(data.token, data.api_token, "0")
                        .then((object) => {
                            logout(this.props.history);
                        })
                }
            })
    }

    toggleCommonModal = () => {
        // const modal = document.getElementById("common-modal");
        // this.setState({
        //     commonmodalState: !this.state.commonmodalState
        // }, () => {
        //     this.state.commonmodalState ? showModal(modal) : hideModal(modal)
        //     this.props.history.push("/dashboard/login");
        // })
        window.scrollTo(0, 0);
        this.props.history.push(
            {
                pathname: '/login',
                state: {basePath: this.props.history.location.pathname}
            }
        );
    }

    toggleConnect = () => {
        sb_util.sendBirdLogin("user");
        this.props.history.push("/dashboard")
    }

    toggleGolive = () => {
        window.scrollTo(0, 0);
        sb_util.sendBirdLogin("broadcaster")
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {

                    if (this.props.account_management.userDetails.phone_number_validated === 0) {
                        this.props.history.push("/verify-mobile", {
                            phone_number_validated: false,
                            api_token: data.api_token,
                            token: data.token,
                            isGolive: true,
                            basePath: this.props.history.location.pathname
                        })
                    } else if (data.is_broadcaster) {
                        this.props.history.push(
                            {
                                pathname: '/broadcaster/create/profile',
                            }
                        )
                    } else {

                        this.props.history.push(
                            {
                                pathname: '/broadcaster/register',
                                state: { basePath: this.props.history.location.pathname }
                            }
                        )
                    }

                } else {
                    this.props.history.push(
                        {
                            pathname: '/register',
                            state: { basePath: this.props.history.location.pathname, isGolive: true }
                        }
                    )
                }
            })
    }

    navCreateBroadcast = () => {
        navigate(this.props, "broadcaster_create_broadcast");
    }

    callYotiIntegration = () => {
        getData(LOGIN)
            .then((data) => {
                if (!isEmpty(data)) {
                    this.props.yotiIntegration(data.token, data.api_token);
                    this.setState({
                        yotiModalStatus: true
                    })
                }
            })
    }

    render() {
        let uri = this.props.location.pathname.split('/');
        return (

            <div>

                <header className="fixed-top">
                    <nav className="navbar navbar-expand-lg navbar-dark">
                        <div className="logo">
                            <div style={{"display": "flex"}}>
                                <button className="nav-toggle" type="button" onClick={this.toggleLeftBar}>
                                    <div className="bar1"></div>
                                    <div className="bar2"></div>
                                    <div className="bar3"></div>
                                </button>
                                <Link to="/dashboard" className="navbar-brand" title="Homepage">
                                    <img
                                        src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/vuepay-text-logo-with-white.svg"}
                                        alt="VuePay Logo" style={{padding: 5}}/>
                                </Link>
                            </div>
                        </div>
                        <ul className="top-nav">
                            <li id="top-nav-watch" className="active">
                                <a className="signin-button" onClick={this.toggleConnect}>Connect</a>
                                {/*<Link to="/dashboard" onClick={this.toggleConnect}>Connect</Link>*/}
                            </li>
                            <li id="top-nav-go-live">
                                <a className="signin-button" onClick={this.toggleGolive}>Share</a>
                                <img style={{verticalAlign: 'middle', paddingBottom: 3}}
                                     src="https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/red-circle.svg"/>
                            </li>
                            <li>

                            </li>
                            <li>
                                <form className="display-flex" onSubmit={this.searchInTheList}>
                                    <input name="searchInput"
                                           className="form-control"
                                           type="text"
                                           onBlur={(event) => this.handleOnBlur(event)}
                                           onChange={(event) => this.handleOnBlur(event)}
                                           placeholder="Search broadcast by username or tags..."
                                           style={{visibility: !this.props.searchbar.isVisible ? "hidden" : ""}}
                                           aria-label="Search"/>
                                    {/*<img src={assets.broadcast.cross} alt={"clear filter"} className="search-input-clear"/>*/}
                                </form>
                            </li>
                        </ul>
                        {
                            this.props.account_management.userDetails === null
                                ?
                                <div className="notify-container singin-right">
                                    <button className="signin-button" onClick={this.toggleCommonModal}>
                                        <FontAwesomeIcon icon={faUserCircle} size="lg" /> Sign in
                                        </button>
                                </div>
                                :
                                <div className="notify-container">
                                    <div className="notify-group">
                                        <div className="dropdown">
                                            <a data-target=""
                                                href="#"
                                                className="nav-link"
                                                id="myDropdown" onClick={this.dropDownClickListener}
                                                role="button"
                                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                <span className="icon-profile">

                                                    {
                                                        (uri[1] == "broadcaster" || uri[1] == "broadcast")
                                                            ?
                                                            (this.props.account_management.userDetails.broadcaster.length > 0)
                                                                ?
                                                                <img alt="Profile"
                                                                    width={30}
                                                                    src={this.props.account_management.userDetails.broadcaster[0].profile_pic} />
                                                                :
                                                                <img alt="Profile"
                                                                    width={30}
                                                                    src={profile_thumb} />
                                                            :
                                                            (this.props.account_management.userDetails && this.props.account_management.userDetails.profile_pic !== null)
                                                                ?
                                                                <img alt="Profile"
                                                                    width={30}
                                                                    src={this.props.account_management.userDetails.profile_pic} />
                                                                :
                                                                <img alt="Profile"
                                                                    width={30}
                                                                    src={profile_thumb} />
                                                    }
                                                </span>
                                                {this.props.account_management.userDetails && <span
                                                    className="name-profile">{this.props.account_management.userDetails.username}</span>}
                                            </a>
                                            <ul
                                                className="dropdown-menu"
                                                aria-labelledby="myDropdown">
                                                <li className="promotions-li">
                                                    <a href="javascript:void(0);"
                                                        title="Promotions"
                                                        onClick={() => showPromocodeVerification()}>
                                                        <img src={my_account} alt="Promotions"/> Promotions
                                                        </a>
                                                </li>

                                                <li className="verify-account-li">
                                                    <a href="javascript:void(0);"
                                                        title="Verify Account"
                                                        onClick={this.callYotiIntegration}>
                                                        <img src={my_account} alt="Verify Account" /> Verify Account
                                                        </a>
                                                </li>
                                                <li className="my-account-li">
                                                    <a href="javascript:void(0);"
                                                        title="My Account"
                                                        onClick={this.showUserProfile}>
                                                        <img src={my_account} alt="My Account" /> My Account
                                                        </a>
                                                </li>
                                                <li className="my-wallet-li">
                                                    <a href="javascript:void(0);"
                                                        title="My Earnings" onClick={() => {
                                                            document.getElementsByClassName("dropdown")[0].classList.toggle("show");
                                                            document.getElementsByClassName("dropdown-menu")[0].classList.toggle("show");
                                                            this.props.history.push("/broadcaster/wallet")
                                                        }
                                                        }>
                                                        <img src={wallet} alt="My Earnings" /> My Earnings
                                                        </a>
                                                </li>
                                                <li className="add-credit-li">
                                                    <a href="javascript:void(0);" title="Add Credit"
                                                        onClick={() => {
                                                            document.getElementsByClassName("dropdown")[0].classList.toggle("show");
                                                            document.getElementsByClassName("dropdown-menu")[0].classList.toggle("show");
                                                            this.props.showMoneyBloxModal()
                                                        }
                                                        }>
                                                        <img src={add_credit} alt="Add Credit" /> Add Credit
                                                        </a>
                                                </li>
                                                <li>
                                                    <label className="logout_lbl" title="Log Out" onClick={() => {
                                                        this.updateStatus()
                                                    }}>
                                                        <img className="logout_img" src={logout_image}
                                                            alt="Log Out" /> <b>Log Out</b>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                        {/*{*/}
                                        {/*this.props.account_management.hasOwnProperty("broadcaster") && this.props.account_management.broadcaster.length > 0 &&*/}
                                        <div className="notification">
                                            <a
                                                href="javascript:void(0);"
                                                title="Notification"
                                                className="notify" onClick={this.toggleNotification}>

                                            </a>
                                        </div>
                                        {/*}*/}
                                    </div>
                                </div>
                        }
                    </nav>
                </header>

                {this.state.userProfileModal && <UserProfile history={this.props.history} />}
                <YotiIframe navCreateBroadcast={this.navCreateBroadcast} />
                <PromoCode />
            </div>

        );
    }
}

NavigationBar = withRouter(NavigationBar);

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        notificationDataList: state.notificationDataList,
        device: state.device.payload,
        following: state.following,
        broadcaster_favourites: state.broadcaster_favourites,
        searchbar: state.searchbar,
        moneyblox: state.moneyblox,
        profanity: state.profanity.words
    };
}

export default connect(mapStateToProps, actions)(NavigationBar);